module.exports = __webpack_public_path__ + "assets/img/dzh-27.e2176e25.jpg";